import { render, staticRenderFns } from "./consigneeModel.vue?vue&type=template&id=4ae8aaea"
import script from "./consigneeModel.vue?vue&type=script&lang=js"
export * from "./consigneeModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae8aaea')) {
      api.createRecord('4ae8aaea', component.options)
    } else {
      api.reload('4ae8aaea', component.options)
    }
    module.hot.accept("./consigneeModel.vue?vue&type=template&id=4ae8aaea", function () {
      api.rerender('4ae8aaea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/modelForm/consigneeModel.vue"
export default component.exports